import { v4 as uuidv4 } from "uuid";
export class PAReviewMeetingActionItemModel {
    constructor() {
        this.id = uuidv4();
        this.description = "";
        this.assignedUserId = "";
        this.assignedUserName = "";
        this.dueDate = null;
        this.dueDateAsString = "";
        this.completedOn = null;
        this.completedOnAsString = "";
        this.isCompleted = false;
        this.canCompleteAction = false;
        this.canPerformActionOperation = false;
    }
}
export default class PAReviewMeetingActionItem extends PAReviewMeetingActionItemModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
